export enum SubmitReturnErrorCode {
  DRAFT_RETURN_NOT_FOUND = "DRAFT_RETURN_NOT_FOUND",
  ORDERS_NOT_FOUND = "ORDERS_NOT_FOUND",
  UNAUTHORIZED = "UNAUTHORIZED",
  PROVISION_TYPE_REQUIRED = "PROVISION_TYPE_REQUIRED",
  PROVISION_TYPE_NOT_ALLOWED = "PROVISION_TYPE_NOT_ALLOWED",
  MISSING_CUSTOMER_SHIPPING_ADDRESS = "MISSING_CUSTOMER_SHIPPING_ADDRESS",
  MISSING_COMPENSATION_METHOD = "MISSING_COMPENSATION_METHOD",
  UNABLE_TO_GET_RETURN_TOTALS = "UNABLE_TO_GET_RETURN_TOTALS",
  MUST_RETURN_ONE_ITEM = "MUST_RETURN_ONE_ITEM",
  RETURN_ALREADY_EXISTS = "RETURN_ALREADY_EXISTS",
  ITEM_ALREADY_RETURNED = "ITEM_ALREADY_RETURNED",
  INVALID_COLLECTION_HOLD_AMOUNT = "INVALID_COLLECTION_HOLD_AMOUNT",
  INVALID_PAYMENT_TOKEN = "INVALID_PAYMENT_TOKEN",
  NO_PAYMENT_TOKEN = "NO_PAYMENT_TOKEN",
  UPSELL_CHARGE_FAILED = "UPSELL_CHARGE_FAILED",
  ON_HOLD_CHARGE_FAILED = "ON_HOLD_CHARGE_FAILED",
  SHIPPING_CHARGE_FAILED = "SHIPPING_CHARGE_FAILED",
  REPAIR_CHARGE_FAILED = "REPAIR_CHARGE_FAILED",
  RETURNABLE_ITEM_NOT_FOUND = "RETURNABLE_ITEM_NOT_FOUND",
  RETURN_NOT_FOUND = "RETURN_NOT_FOUND",
  UNABLE_TO_UPDATE_ORDER_WITH_EXCHANGE_ITEMS = "UNABLE_TO_UPDATE_ORDER_WITH_EXCHANGE_ITEMS",
  LABEL_PRICE_TOO_HIGH = "LABEL_PRICE_TOO_HIGH",
  NOTIFYING_FAILED_NOT_RETRYING_FIX_ME = "NOTIFYING_FAILED_NOT_RETRYING_FIX_ME",
  NO_CUSTOMER_FOUND = "NO_CUSTOMER_FOUND",
  LABEL_PAYER_REQUIRED = "LABEL_PAYER_REQUIRED",
  NO_CHARGES = "NO_CHARGES",
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR", // Shouldn't intentionally throw this; only a catch-all for storing error code on draft return
}

const CHECK_CARD_SNIPPET = "Please check your card details and try again.";

export const friendlySubmitReturnErrorMessages: Record<
  SubmitReturnErrorCode,
  string
> = {
  [SubmitReturnErrorCode.DRAFT_RETURN_NOT_FOUND]:
    "We couldn't find the return you were trying to submit. This may be because you were inactive on this page for too long. Try recreating the return.",
  [SubmitReturnErrorCode.ORDERS_NOT_FOUND]:
    "We couldn't find the order for the return you were trying to submit.",
  [SubmitReturnErrorCode.UNAUTHORIZED]:
    "You don't have permission to submit this return.",
  [SubmitReturnErrorCode.PROVISION_TYPE_REQUIRED]:
    "The return request should have either instant exchange or standard exchange selected. Try selecting one, or contact support.",
  [SubmitReturnErrorCode.PROVISION_TYPE_NOT_ALLOWED]:
    "Instant exchange is not allowed for this return. Please select standard exchange instead.",
  [SubmitReturnErrorCode.MISSING_CUSTOMER_SHIPPING_ADDRESS]:
    "You must provide a shipping address to submit a return.",
  [SubmitReturnErrorCode.MISSING_COMPENSATION_METHOD]:
    "The return request is missing a refund method. Please contact support.",
  [SubmitReturnErrorCode.UNABLE_TO_GET_RETURN_TOTALS]:
    "We couldn't calculate the pricing information for the return. Please try again.",
  [SubmitReturnErrorCode.MUST_RETURN_ONE_ITEM]:
    "You must return at least one item.",
  [SubmitReturnErrorCode.RETURN_ALREADY_EXISTS]:
    "The return you're trying to submit already exists.",
  [SubmitReturnErrorCode.ITEM_ALREADY_RETURNED]:
    "One of the items you're trying to return has already been returned. If you didn't expect this, please contact support.",
  [SubmitReturnErrorCode.INVALID_COLLECTION_HOLD_AMOUNT]:
    "We tried to place a hold on your card for instant exchange but we were unable to. Please contact support.",
  [SubmitReturnErrorCode.INVALID_PAYMENT_TOKEN]:
    "The payment information you provided is invalid. " + CHECK_CARD_SNIPPET,
  [SubmitReturnErrorCode.NO_PAYMENT_TOKEN]:
    "The return request is missing payment information. Please contact support.",
  [SubmitReturnErrorCode.UPSELL_CHARGE_FAILED]:
    "We couldn't process the upsell charge. " + CHECK_CARD_SNIPPET,
  [SubmitReturnErrorCode.ON_HOLD_CHARGE_FAILED]:
    "We couldn't process the on hold charge. " + CHECK_CARD_SNIPPET,
  [SubmitReturnErrorCode.SHIPPING_CHARGE_FAILED]:
    "We couldn't process the shipping charge. " + CHECK_CARD_SNIPPET,
  [SubmitReturnErrorCode.RETURNABLE_ITEM_NOT_FOUND]:
    "One of the items you're trying to return was not found.",
  [SubmitReturnErrorCode.RETURN_NOT_FOUND]:
    "The return you're trying to submit was not found.",
  [SubmitReturnErrorCode.UNABLE_TO_UPDATE_ORDER_WITH_EXCHANGE_ITEMS]:
    "We couldn't update the new order with exchange items. Please try again.",
  [SubmitReturnErrorCode.LABEL_PRICE_TOO_HIGH]:
    "The label price is too high. Please try again.",
  [SubmitReturnErrorCode.NOTIFYING_FAILED_NOT_RETRYING_FIX_ME]:
    "We submitted your return, but failed to send you a notification. Please contact support.",
  [SubmitReturnErrorCode.NO_CUSTOMER_FOUND]:
    "We couldn't find a customer for your return. Please contact support.",
  [SubmitReturnErrorCode.LABEL_PAYER_REQUIRED]:
    "The return request is missing a label payer. Please contact support.",
  [SubmitReturnErrorCode.INTERNAL_SERVER_ERROR]:
    "An internal server error occurred while submitting the return. Please contact support.",
  [SubmitReturnErrorCode.REPAIR_CHARGE_FAILED]:
    "We were unable to charge your card for the repair fee, please check your payment information and try again.",
  [SubmitReturnErrorCode.NO_CHARGES]:
    "We expected to charge you for this return, but all charge were zero dollars. Please contact support.",
};
